// Shared furniture for the two « phone app » cards on the dashboard (« Install
// the app », « Turn on notifications »). Small on purpose: they sit above the
// numbers and must not push them down.
import type { ReactNode } from 'react';

const Svg = ({ children, className = 'w-4 h-4' }: { children: ReactNode; className?: string }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={`${className} shrink-0`} aria-hidden>
    {children}
  </svg>
);

export const PhoneIcon = () => <Svg><rect x="7" y="2.5" width="10" height="19" rx="2.2" /><path d="M11 18.5h2" /></Svg>;
export const BellIcon = () => <Svg><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></Svg>;
/** iOS « Share »: a box with an arrow going up. */
export const ShareIcon = () => <Svg className="w-3.5 h-3.5"><path d="M12 3v11" /><path d="M8 7l4-4 4 4" /><path d="M6 11H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-1" /></Svg>;
/** iOS « Add to Home Screen »: a plus in a rounded square. */
export const AddSquareIcon = () => <Svg className="w-3.5 h-3.5"><rect x="4" y="4" width="16" height="16" rx="4" /><path d="M12 8.5v7M8.5 12h7" /></Svg>;

export function PhoneCard({ icon, title, onClose, children }: {
  icon: ReactNode;
  title: string;
  /** Shows a × that calls this. */
  onClose?: () => void;
  children: ReactNode;
}) {
  return (
    <section className="bg-white rounded-xl border border-gray-100 shadow-[0_1px_2px_rgba(46,36,24,0.04)] px-4 py-3 flex items-start gap-3">
      <span className="mt-0.5 grid place-items-center w-8 h-8 rounded-lg shrink-0" style={{ background: 'rgba(201,162,74,0.12)', color: 'var(--color-adm-gold-ink)' }}>
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <h2 className="text-sm font-semibold text-gray-900" style={{ fontFamily: 'inherit' }}>{title}</h2>
        <div className="mt-0.5 text-xs text-gray-600 leading-relaxed">{children}</div>
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="-mr-1 -mt-0.5 w-8 h-8 grid place-items-center rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-50 shrink-0"
        >
          <Svg><path d="M18 6L6 18M6 6l12 12" /></Svg>
        </button>
      )}
    </section>
  );
}
